import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { FormHelper } from './form.helper';

export const VALIDATION_ERROR_PASSWORD_POLICY_DEFAULT = 'password-policy-default';
export const VALIDATION_ERROR_USERNAME_CHARS = 'username-safe-characters';

export const VALIDATION_MESSAGE_PASSWORD_POLICY_DEFAULT = 'The password violates the password policy.';
export const VALIDATION_MESSAGE_USERNAME_CHARS = 'The username must not contain any of the following characters: / : & = # ? \\ ;';

const notUserNameSafe: RegExp = /[/:&=#?;\\]+/;

export class Adm4FormValidators {

  static requiredArray: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    if (!control) {
      return null;
    }
    const value: unknown = control.value;
    if (Array.isArray(value) && value.length > 0) {
      return null;
    } else {
      return {
        [FormHelper.VALIDATION_KEY_REQUIRED]: true,
      };
    }
  };

  static userNameSafeCharacters: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    if (notUserNameSafe.test(control?.value)) {
      return {[VALIDATION_ERROR_USERNAME_CHARS]: true};
    }
    return null;
  };
}
